import React from 'react';

const Workshop = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Workshop</h1>
        <p>Regional Infrastructure, Climate, Security & Green Investment Workshops</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h2>Upcoming Workshop</h2>
              <button className="btn-gold" onClick={() => window.location.href='/upcoming-workshop'}>View Upcoming</button>
            </div>
            <div className="content-card">
              <h2>Past Workshop</h2>
              <button className="btn-gold" onClick={() => window.location.href='/past-workshop'}>View Past</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Workshop;